// extracted by mini-css-extract-plugin
export default {"container":"MySearchTemplate_container__0QlrH","sideDrawer__content":"MySearchTemplate_sideDrawer__content__Y4Nat"};